/**
 * @description: 应用平台
 * @return {*}
 */
export const PLATFORM = {
  ANDROID: 1,
  IOS: 2,
  MINIGAME: 3
}

export const GDT_MENU_ID = 'M21081'

export const PLATFORM_LIST = [
  {
    label: '安卓',
    value: PLATFORM.ANDROID
  },
  {
    label: 'IOS',
    value: PLATFORM.IOS
  },
  {
    label: '微信小游戏',
    value: PLATFORM.MINIGAME
  }
]

/**
 * @description: 营销目的
 * @return {*}
 */
const USER_GROWTH = 'MARKETING_GOAL_USER_GROWTH'
export const MARKETING_TYPE = {
  USER_GROWTH
}

/**
 * @description: 广告场景，内部字段，无需提交到媒体
 * @return {*}
 */
const VERSION_3 = 'VERSION_3'
const VERSION_SMART = 'VERSION_SMART'
const VERSION_SEARCH = 'VERSION_SEARCH'
export const AD_MARKETING_SCENE = {
  VERSION_3, VERSION_SMART, VERSION_SEARCH
}

/**
 * @description: 智投广告场景类型枚举smart_delivery_platform枚举
 * @return {*}
 */
const MINI_GAME_PROMOTION = 'SMART_DELIVERY_PLATFORM_EDITION_MINI_GAME_PROMOTION' // 小游戏跑量
const MULTI_OPTIMIZATION = 'SMART_DELIVERY_PLATFORM_EDITION_MULTI_OPTIMIZATION' // 多目标优化
const GAME_APP = 'SMART_DELIVERY_PLATFORM_EDITION_GAME_APP' // 游戏应用智投
export const SMART_DELIVERY_PLATFORM = {
  MINI_GAME_PROMOTION, MULTI_OPTIMIZATION, GAME_APP
}

/**
 * @description: 二级营销目的
 * @return {*}
 */
const NEW_GAME_RESERVE = 'MARKETING_SUB_GOAL_NEW_GAME_RESERVE'
const NEW_GAME_TEST = 'MARKETING_SUB_GOAL_NEW_GAME_TEST'
const NEW_GAME_LAUNCH = 'MARKETING_SUB_GOAL_NEW_GAME_LAUNCH'
const PLATEAU_PHASE_LAUNCH = 'MARKETING_SUB_GOAL_PLATEAU_PHASE_LAUNCH'
const MINI_GAME_NEW_CUSTOMER_GROWTH = 'MARKETING_SUB_GOAL_MINI_GAME_NEW_CUSTOMER_GROWTH'
const RETURN_CUSTOMER_ENGAGEMENT = 'MARKETING_SUB_GOAL_MINI_GAME_RETURN_CUSTOMER_ENGAGEMENT'
export const MARKETING_SUB_GOAL = {
  NEW_GAME_RESERVE,
  NEW_GAME_TEST,
  NEW_GAME_LAUNCH,
  PLATEAU_PHASE_LAUNCH,
  MINI_GAME_NEW_CUSTOMER_GROWTH,
  RETURN_CUSTOMER_ENGAGEMENT
}
export const MARKETING_SUB_GOAL_LIST = [
  {
    label: '平推期投放',
    value: PLATEAU_PHASE_LAUNCH
  },
  {
    label: '新游测试',
    value: NEW_GAME_TEST
  },
  {
    label: '新游预约',
    value: NEW_GAME_RESERVE
  },
  {
    label: '新游首发',
    value: NEW_GAME_LAUNCH
  }
]

// 小游戏的二级营销目的
export const MINI_GAME_MARKETING_SUB_GOAL = {
  NEW_GAME_TEST,
  MINI_GAME_NEW_CUSTOMER_GROWTH
}

export const MINI_GAME_MARKETING_SUB_GOAL_LIST = [
  {
    label: '新客增长',
    value: MINI_GAME_NEW_CUSTOMER_GROWTH
  },
  {
    label: '新游测试',
    value: NEW_GAME_TEST
  },
  {
    label: '回流触达',
    value: RETURN_CUSTOMER_ENGAGEMENT
  }
]

/**
 * @description: 营销对象
 * @return {*}
 */
export const MARKETING_CARRIER_TYPE = {
  APP_ANDROID: 'MARKETING_CARRIER_TYPE_APP_ANDROID',
  APP_IOS: 'MARKETING_CARRIER_TYPE_APP_IOS',
  MINI_GAME: 'MARKETING_CARRIER_TYPE_WECHAT_MINI_GAME'
}

/**
 * @description: 推广目标类型
 * @return {*}
 */
const APP_IOS = 'PROMOTED_OBJECT_TYPE_APP_IOS'
const APP_ANDROID = 'PROMOTED_OBJECT_TYPE_APP_ANDROID'
const MINI_GAME_WECHAT = 'PROMOTED_OBJECT_TYPE_MINI_GAME_WECHAT'
export const PROMOTED_TYPE = {
  APP_ANDROID,
  APP_IOS,
  MINI_GAME_WECHAT
}
export const PROMOTED_TYPE_LIST = [APP_ANDROID, APP_IOS, MINI_GAME_WECHAT]

/**
 * @description: 根据应用平台获取推广目的
 * @return {*}
 */
export const PROMOTED_TYPE_BY_PLATFORM = {
  [PLATFORM.ANDROID]: APP_ANDROID,
  [PLATFORM.IOS]: APP_IOS,
  [PLATFORM.MINIGAME]: MINI_GAME_WECHAT
}

/**
 * @description: 一方人群跑量加强开关状态
 */
export const ECOM_CLOSE = 'ECOM_PKAM_SWITCH_CLOSE'
export const ECOM_OPEN = 'ECOM_PKAM_SWITCH_OPEN'
export const ECOM_PKAM = {
  OPEN: ECOM_OPEN,
  CLOSE: ECOM_CLOSE
}

export const ADA_DYNAMIC_WORDS = ['日期', '时间', '定向包名', '创意组名']
export const V3_DYNAMIC_WORDS = ['日期', '时间', '定向包名', '账号简称']
export const IMG_URL_MD5_REGEXP = /(?<=\/)([a-f0-9]{32})(?=\.)/

// export const SEARCH_AD_BID_KEYWORD_PATERN = [
//   { label: '广泛', value: 'WIDE_MATCH' },
//   { label: '短语', value: 'WORD_MATCH' },
//   { label: '精确', value: 'EXACT_MATCH' },
//   { label: '短语核心匹配', value: 'PHRASE_MATCH' }
// ]

export const SEARCH_AD_BID_KEYWORD_PATERN = [
  { label: '智能匹配', value: 'WIDE_MATCH' }
]
